import React from 'react';
import ViewLeavesPage from './ViewLeavesPage';
import { APPROVE_LEAVE_HEADER } from './ViewAttendeesPageHelper';
import { LEAVE_PAGE_TYPE } from '../../utils/Constant';

const ApproveLeave: React.FunctionComponent = () => {
  return (
    <ViewLeavesPage
      type={LEAVE_PAGE_TYPE.APPROVE_LEAVE}
      columnsHeder={APPROVE_LEAVE_HEADER}
      title="Leave Pending Requests"
    />
  );
};
export default ApproveLeave;
